import React, { FC } from 'react';
import { ValidationMessage, FormCol, FormRow } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import NewPasswordValidation from './NewPasswordValidation';
import PasswordStrengthLabel from './PasswordStrengthLabel';
import PasswordControl from './PasswordControl';

export interface NewPasswordInputProps { }

const NewPasswordInput: FC<NewPasswordInputProps> = () => {
  const { t } = useTranslation('ChangePasswordSection');

  return (
    <>
      <FormRow>
        <FormCol id="passwordLabel" label={t('EnterPassword')} labelMarginBottom={12}>
          <NewPasswordValidation />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol labelMarginBottom={12}>
          <PasswordStrengthLabel />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol labelMarginBottom={36}>
          <PasswordControl />
          <ValidationMessage type="required">{t('PasswordRequired')}</ValidationMessage>
        </FormCol>
      </FormRow>
    </>
  );
};

export default NewPasswordInput;
